import Actor from "../../actors/Actor";
import ParticleEmitter from "../../reusableModules/ParticleEmitter";
import common from "../../common";

export default class Ingredient extends Actor {
    constructor(textures, position, particleData, particleTextures) {
        super(textures.shelf);
        this.x = position.x;
        this.y = position.y;
        this.view.anchor.set(0.5, 1);
        this.view.scale.set(0.7);
        this.interactive = false;

        this._completed = false;

        this._fullTexture = textures.shelf;
        this._emptyTexture = textures.empty;
        this._respawnPosition = position;
        this._emitter = null;
        this._particleData = particleData;
        this._particleTextures = particleTextures;

        this.buttonMode = true;
        this.on('pointerdown', this.onDragStart);
        this.on('pointerup', this.onDragEnd);
        this.on('pointerupoutside', this.onDragEnd);
        this.on('pointermove', this.onDragMove);

        this.createEmitter(particleData, particleTextures);

        this.signals = {};
        this.signals.dragStart = new P3.utils.MiniSignal();
        this.signals.dragEnd = new P3.utils.MiniSignal();
        this.signals.remove = new P3.utils.MiniSignal();
    }

    removeInteractions(){
        this.off('pointerdown');
        this.off('pointerup');
        this.off('pointerupoutside');
        this.off('pointermove');
    }

    update() {
        super.update();
        this._emitter.update(P3.Ticker.dt);
    }

    createEmitter(particleData, particleTextures) {
        this._emitter = new ParticleEmitter(particleData, particleTextures, true);
        this._emitter.scale.set(0.7);
        this._emitter.position.set(this.determineEmitterPosition(this._fullTexture), -this.view.height * 0.25);
        this._fullTexture.textureCacheIds[0] === "ing_egg_shelf.png" ? this.addChildAt(this._emitter,0) : this.addChild(this._emitter);
    }

    respawn() {
        this.x = this._respawnPosition.x;
        this.y = this._respawnPosition.y;
        this.view.rotation = 0;
        this.createEmitter(this._particleData, this._particleTextures);
    }

    onDragStart(event) {
        if(!this.interactive) return;
        this.simpleFloat();
        this.data = event.data;
        this.dragging = true;
        this.dropped = false;
        let sounds = [
            'sfx_pickup_ingredient_00',
            'sfx_pickup_ingredient_01',
            'sfx_pickup_ingredient_02',
            'sfx_pickup_ingredient_03',
            'sfx_pickup_ingredient_04'
        ];
        P3.audio.playSound(common.randomSelection(sounds));
        this.signals.dragStart.dispatch();
    }

    onDragEnd() {
        if (this.dragging) {
            this._floatup.stop();
            this._floatdown.stop();
            this.dragging = false;
            this.dropped = true;
            this.data = null;
            this.signals.dragEnd.dispatch(this);
            //console.log(this.y);
        }
    }

    onDragMove() {
        if (this.dragging) {
            let newPos = this.data.getLocalPosition(this.parent);
            this.x = newPos.x;
            this.y = newPos.y < 508 ? newPos.y : 507;
        }
    }

    simpleFloat(){
        this._floatup = new P3.utils.TWEEN.Tween(this.view)
            .to({
                y: "+10"
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        this._floatdown = new P3.utils.TWEEN.Tween(this.view)
            .to({
                y: "-10"
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        this._floatup.chain(this._floatdown);
        this._floatdown.chain(this._floatup);
        this._floatup.start();
    }

    playAnimation(isComplete) {
        let rotate = new P3.utils.TWEEN.Tween(this.view)
            .to({
                rotation: common.deg2rad(50)
            }, 600)
            .onStart(()=>{
                this.interactive = false;
                this.view.texture = this._emptyTexture;
                this._emitter.visible = true;

                let config = this._emitter._config;
                config.emitterLifetime = this.determineEmitterLifetime();
                config.lifetime = {
                    "min": config.emitterLifetime,
                    "max": config.emitterLifetime
                };
                this._emitter.overrideDefaultConfig(config);

                this._emitter._emitter.playOnceAndDestroy(() => {
                    if (isComplete) {
                        this._completed = true;
                        this.view.texture = this._emptyTexture;
                        this.floatBackAnimation();
                        this.signals.remove.dispatch(this.id);

                    } else {
                        this.floatBackAnimation();
                        this.createEmitter(this._particleData, this._particleTextures);
                        this.view.texture = this._fullTexture;
                    }
                });
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    rotateWithoutParticle(){
        let shake_1 = new P3.utils.TWEEN.Tween(this.view)
            .to({
                rotation: common.deg2rad(5)
            }, 200)
            .onStart(()=>{
                this.interactive = false;
            });

        let shake_2 = new P3.utils.TWEEN.Tween(this.view)
            .to({
                rotation: common.deg2rad(-5)
            }, 200)
            .onComplete(()=>{
                this.floatBackAnimation();
            });

        shake_1.chain(shake_2);
        shake_1.start();
    }

    floatBackAnimation(){
        this.interactive = false;

        if(!this._completed){
            new P3.utils.TWEEN.Tween(this)
                .to({
                    x: this._respawnPosition.x, y: this._respawnPosition.y,
                }, 1000)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(()=>{
                    this.interactive = true;
                })
                .start();
        }else{
            new P3.utils.TWEEN.Tween(this)
                .to({
                    x: 0, y: 0,
                }, 1000)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();
        }


        new P3.utils.TWEEN.Tween(this.view)
            .to({
                rotation:0
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    determineEmitterLifetime(){
        if(this.y < 210){
            if(this.y < 150){
                return 1.5;
            }else {
                return 1.2;
            }
        }else{
            if(this.y < 400){
                if(this.y < 300){
                    return 1;
                }else{
                    return 0.75;
                }
            }else{
                return 0.6;
            }
        }
    }

    determineEmitterPosition(texture){
        switch (texture.textureCacheIds[0]) {
            case "ing_flour_shelf.png":
                return this.view.width * 0.5 + 15;
            case "ing_eggs_shelf.png":
                return this.view.width * 0.5 + 10;
            default:
                return this.view.width * 0.5;
        }
    }
}
